export default {
  // Common words
  enter: "Mynd i mewn",
  next: "Nesaf",
  previous: "Blaenorol",
  finish: "Gorffen",
  returnToWebsite: "Dychwelyd i'r Wefan",
  complete: "Cyflawn",
  submit: "Cyflwyno",
  cancel: "Canslo",
  yes: "Ie",
  no: "Na",
  skip: "Neidio",
  close: "Cau",
  discard: "Taflu",
  save: "Cadw",
  "thank-you": "Diolch",
  select: "Dewis",
  hi: "Helo",
  hello: "Helo",
  link: "Dolen",
  back: "Yn ôl",
  view: "Gweld",
  continue: "Parhau",
  of: "o",

  // Client Survey Main
  "client-survey-main-thanks-note":
    "Diolch am gymryd yr amser, mae eich adborth yn siapio ein cynnig <br /> ar gyfer y dyfodol.",
  "client-survey-how-likely-recommend":
    "Pa mor debygol fyddech chi o'n hargymell ni i eraill?",
  "client-survey-how-likely-note":
    "Ar raddfa 0 - 10, lle mae 0 yn ddim yn debygol o gwbl a 10 yn hynod debygol.",
  "client-survey-how-likely-recommend-question":
    "Beth yw'r un peth y gallem ei wneud i'ch gwneud yn fwy tebygol o'n hargymell ni?",
  "step-of": "Cam {step} o {total}",
  step: "Cam {step}",
  "client-survey-how-satisfied-with-service":
    "Pa mor fodlon ydych chi gyda'r gwasanaeth",
  "client-survey-how-satisfied-with-service-question":
    "Beth yw'r un peth y gallem ei wneud i wella?",
  "client-survey-how-satisfied-with-food":
    "Pa mor fodlon ydych chi gyda'r bwyd rydych chi'n ei dderbyn gennym ni?",
  "client-survey-how-satisfied-with-food-question":
    "Beth yw'r un peth y gallem ei wneud i wella?",
  "client-survey-what-is-the-best-thing-about-working-with-us":
    "Beth yw'r peth gorau am weithio gyda ni? Dewiswch bopeth sy'n bwysig.",
  "management-team": "Tîm Rheoli",
  "the-front-line-operations-team": "Y tîm gweithrediadau rheng flaen",
  "food-offering": "Cynnig Bwyd",
  innovation: "Arloesedd",
  communication: "Cyfathrebu",
  "flexibility-and-responsiveness": "Hyblygrwydd ac Ymatebolrwydd",
  billing: "Bilio",
  "health-and-hygiene-standards": "Safonau Iechyd a Hylendid",
  "if-other-please-specify": "Os arall, nodwch...",
  "based-on-the-service-we-provide-where-can-we-improve-the-most-please-select-all-that-matters":
    "Yn seiliedig ar y gwasanaeth rydym yn ei ddarparu, ble gallwn ni wella fwyaf? Dewiswch bopeth sy'n bwysig.",
  "please-can-we-have-some-more-detail": "A allwn ni gael mwy o fanylion?",
  "to-help-us-understand-your-csr-priorities-please-order-in-rank-of-importance-the-following":
    "I'n helpu ni i ddeall eich blaenoriaethau CSR, trefnwch yn nhrefn pwysigrwydd y canlynol:",
  "sustainable-ingredients": "Cynhwysion Cynaliadwy",
  "food-waste": "Gwastraff Bwyd",
  "local-sourcing": "Caffael Lleol",
  "people-and-communities": "Pobl &amp; Cymunedau",
  "energy-reduction": "Gostyngiad Ynni",
  "working-with-local-communities": "Gweithio gyda chymunedau lleol",
  "environmental-choices": "Dewisiadau Amgylcheddol",
  "meat-free": "Heb Gig",
  "less-plastic": "Llai o Blastig",
  "would-you-like-to-be-contacted-about-your-feedback":
    "Hoffech chi gael eich cysylltu ynghylch eich adborth? Os felly, gadewch eich gwybodaeth gyswllt isod",
  "full-name": "Enw Llawn",
  "email-address": "Cyfeiriad E-bost",
  "phone-number": "Rhif Ffôn",
  feedback: "Adborth",
  "view-our-privacy-policy": "Gweld ein Polisi Preifatrwydd",
  "thank-you-for-taking-time-to-complete-the-survey":
    "Diolch am gymryd amser i gwblhau'r arolwg!",

  // 404 Not Found
  "404-not-found": "404 Heb ei Ganfod",

  // Privacy Policy
  "privacy-policy": "Polisi Preifatrwydd",

  // Employee Web Rating Feedback Step 1
  "employee-web-rating-feedback-step-1-positive":
    "Falch o glywed eich bod chi'n teimlo'n gadarnhaol, hoffem wybod pam?",
  "employee-web-rating-feedback-step-1-negative":
    "Mae'n ddrwg gennym glywed nad ydych chi'n teimlo'r gorau, a allwch chi ddweud wrthym pam?",

  // Employee Web Rating Feedback Step 2
  "employee-web-rating-feedback-step-2-heading":
    "Oes unrhyw beth arall hoffech chi ei rannu gyda ni heddiw?",
  "employee-web-rating-feedback-step-2-information":
    "Oes gennych chi unrhyw sylwadau neu adborth am eich profiad gyda ni heddiw?",
  "employee-web-rating-feedback-step-2-placeholder":
    "Rhannwch eich profiad gyda ni heddiw...",

  // Employee Web Rating Feedback Step 3
  "employee-web-rating-feedback-step-3-heading":
    "Hoffech chi roi clod i rywun?",
  "no-employees-found": "Dim Gweithwyr wedi'u Canfod",

  // Employee Web Rating Home
  "choose-location": "Dewis Lleoliad",
  "search-location": "Chwilio Lleoliad",
  "feedback-anonymous": "Ydych chi eisiau cadw eich adborth yn ddienw?",
  "feedback-feeling-today": "Sut ydych chi'n teimlo heddiw?",

  // Employee Web Rating Thankyou Page
  "thank-you-for-your-feedback": "Diolch Am Eich Adborth!",
  "back-to-home": "Yn Ôl i'r Cartref",
  page: "Tudalen",

  // Feedback Once Alert
  "feedback-once-alert": "Mae adborth wedi'i roi unwaith o'r URL hwn.",

  // Front Customer Audit
  "please-answer-above-question": "Atebwch y cwestiwn uchod.",
  "add-comments": "Ychwanegu Sylwadau",
  "enter-answer": "Rhoi Ateb",
  "add-upload-files": "Ychwanegu Ffeiliau Uwchlwytho",

  // Alphega Questions
  "did-you-buy-medicine-in-the-pharmacy-today":
    "Wnaethoch chi brynu meddyginiaeth yn y fferyllfa heddiw?",
  "were-you-asked-any-of-the-following":
    "Gofynnwyd unrhyw un o'r canlynol i chi:",
  "who-is-the-medicine-for": "Ar gyfer pwy mae'r feddyginiaeth?",
  "what-are-your-symptoms": "Beth yw eich symptomau?",
  "how-long-you-had-the-symptoms":
    "Pa mor hir rydych chi wedi cael y symptomau?",
  "what-action-you-have-already-taken":
    "Pa gamau rydych chi eisoes wedi'u cymryd?",
  "are-you-taking-any-other-medication":
    "Ydych chi'n cymryd unrhyw feddyginiaeth arall?",

  // Alphega - Other Companies Questions
  "did-you-wait-more-than-10-minutes-to-be-served":
    "Ydych chi wedi gorffen o 10 munud i gael y gwasanaeth?",
  "were-the-products-you-wanted-in-stock":
    "Wnaethoch chi gael y producau rydych yn ei angen yn y stoc?",
  "were-the-staff-friendly-and-helpful":
    "Wnaethoch chi gael y personel yn dda ar eich gilydd?",
  "did-you-receive-any-advice-about-your-medicines":
    "Wnaethoch chi derbyn unrhyw awgrymiadau am eich meddyginiaethau?",

  // Front Mobile Home
  "how-was-your-experience-with-us-today":
    "Sut oedd eich profiad gyda ni heddiw?",

  // Front Mobile Thankyou Page
  "thank-you-for-your-time-and-your-answers":
    "Diolch am eich amser a'ch atebion.",
  "would-also-like-to-rate-us-on-google":
    "Hoffech chi hefyd ein graddio ar Google?",
  "rate-us-now": "Gradiwch ni nawr",

  // Negative Chat Reply
  "select-skill": "Dewis Sgil",
  "none-selected": "Dim wedi'i Ddewis",
  "can-we-get-in-touch-with-you-about-your-experience-today":
    "Allwn ni gysylltu â chi ynghylch eich profiad heddiw?",
  "write-here": "Ysgrifennwch yma...",
  "please-can-we-get-your-name": "A allwn ni gael eich enw?",
  "please-enter-your-email": "Rhowch eich e-bost:",
  "enter-your-phone-number": "Rhowch eich rhif ffôn:",
  "please-tell-us-a-bit-more-about-your-experience":
    "Dywedwch ychydig mwy wrthym am eich profiad:",
  "you-have-already-submitted-rating":
    "Rydych chi eisoes wedi cyflwyno graddiad",
  "sorry-to-hear-you-didn-t-have-the-best-experience-today-with-us-please-could-you-highlight-what-went-wrong":
    "Mae'n ddrwg gennym glywed na chawsoch chi'r profiad gorau heddiw gyda ni, a allech chi nodi beth aeth o'i le?",

  // Positive Chat Reply
  "select-employee": "Dewis Gweithiwr",
  "we-d-love-to-know-who-looked-after-you-today":
    "Hoffem wybod pwy edrychodd ar eich ôl heddiw?",
  "what-stood-out-to-you-today": "Beth oedd yn sefyll allan i chi heddiw?",
  "did-we-provide-exceptional-service-today":
    "Wnaethom ddarparu gwasanaeth eithriadol heddiw?",
  "do-you-have-any-comments-or-feedback-about-your-experience-with-us-today":
    "Oes gennych chi unrhyw sylwadau neu adborth am eich profiad gyda ni heddiw?",

  // Client Connect Director
  "message-from-leadership": "Neges gan Arweinyddiaeth",
  "message-from-leadership-text":
    "Rwy'n chwilio'n gyson am ffyrdd i wella ein cynigion ar gyfer ein cwsmeriaid. Oes agweddau y gallem eu gwella yn eich barn chi?",
  "client-connect-director-another-note":
    "Ar nodyn arall, os oes pwnc penodol hoffech chi i'n tîm ei drafod, peidiwch â petruso i rannu. Nid wyf yma i wrando yn unig, ond i ymgysylltu a gweithredu ar eich pryderon neu syniadau.",
  "your-message-here": "Eich neges yma",
  "visit-information": "Gwybodaeth Ymweliad",
  "visit-time-out": "Amser Allan Ymweliad",
  "contact-information": "Gwybodaeth Gyswllt",
  "client-connect-director-contact-information-text":
    "I ddarparu cymorth gwell, gofynnwn yn garedig am eich manylion, gan gynnwys eich enw, cyfeiriad e-bost, a rhif cyswllt. Bydd y wybodaeth hon yn ein galluogi i ymateb yn brydlon a chysylltu â chi.",
  name: "Enw",
  "enter-your-name": "Rhowch eich enw",
  email: "E-bost",
  "enter-your-email": "Rhowch eich e-bost",
  "contact-number": "Rhif Cyswllt",
  "please-enter-your-name": "Rhowch eich enw",
  "please-enter-your-email-or-phone-number": "Rhowch eich e-bost neu rif ffôn",
  "invalid-email-address": "Cyfeiriad e-bost annilys",
  "invalid-phone-number-format":
    "Rhif ffôn annilys ar gyfer y wlad a ddewiswyd.",
  "no-match-found": "Dim canlyniad",
  "phone-number-must-be-digits-for-country":
    "Rhaid i'r rhif ffôn fod yn {count} digid ar gyfer y wlad a ddewiswyd ({current}/{count}).",
  "phone-number-must-be-digits-range-for-country":
    "Rhaid i'r rhif ffôn fod rhwng {min} a {max} digid ar gyfer y wlad a ddewiswyd ({current}/{max}).",
  "please-select-time": "Dewiswch amser",
  "you-must-provide-at-least-one-answer-before-submitting-the-survey":
    "Rhaid i chi ddarparu o leiaf un ateb cyn cyflwyno'r arolwg.",

  // Mobile Survey Questions CheckBoxType
  comment: "Sylw",
  "comment-is-required": "Mae Sylw yn Ofynnol!",
  "minimum-selection-is": "Dewis lleiaf yw {min_options}",
  "maximum-selection-is": "Dewis uchaf yw {max_options}",
  "this-question-is-required": "Mae'r Cwestiwn hwn yn Ofynnol!",
  "please-fill-all-required-grid-rows": "Llenwch holl resi grid gofynnol!",
  "please-fill-mandatory-fields-to-continue":
    "Cwblhewch y meysydd gorfodol i barhau",

  // Mobile Survey Questions CommentsAndImage
  "please-select-valid-image-files": "Dewiswch ffeiliau delwedd dilys.",

  // Mobile Survey Questions EmployeeType
  loading: "Llwytho",
  "getting-employee": "Cael gweithiwr...",

  // Mobile Survey Questions FileUploadType
  "please-select-valid-image-or-video-files":
    "Dewiswch ffeiliau delwedd neu fideo dilys.",
  "please-select-a-valid-file":
    "Dewiswch ffeil dilys (delwedd, fideo, PDF, neu Word).",

  // Mobile Survey Questions NumberType
  "please-enter-a-number-without-any-decimal-points":
    "Rhowch rif heb unrhyw bwyntiau degol.",
  "please-enter-a-number-less-than-or-equal-to":
    "Rhowch rif sy'n llai na neu'n hafal i {max_number_value}.",

  // Mobile Survey Questions SignatureType
  "please-complete-your-signature": "Cwblhewch eich llofnod.",

  // Mobile Survey Questions TextType
  "please-enter-valid-email-address": "Rhowch gyfeiriad e-bost dilys.",
  "phone-number-should-be-10-digit": "Dylai'r rhif ffôn fod yn 10 digid.",
  "please-enter-at-least-characters": "Rhowch o leiaf {minimum_character} nod.",
  "select-date": "Dewis Dyddiad",
  "select-time": "Dewis Amser",
  "client-connect-date-picker-aria": "Dyddiad: {value}. Agor dewisydd dyddiad",
  "client-connect-time-picker-aria": "Amser: {value}. Agor dewisydd amser",
  "select-country": "Dewis Gwlad",

  // Report Page
  "click-the-link-to-see-how": "Cliciwch y ddolen i weld sut.",
  "adding-your-teams-to-the-ServeFirst-reporting-platform":
    "Trwy ychwanegu eich timau i blatfform adrodd ServeFirst y gallant hefyd fewngofnodi i weld eu perfformiad, hefyd; mae gennych y gallu i reoli eich tîm a chael mynediad at adroddiadau ychwanegol i ddeall sut rydych chi'n perfformio'n gyffredinol -",
  "did-you-know": "Oeddech chi'n gwybod..",

  count: "cyfrif",
  average: "cyfartaledd",
  focus: "ffocws",
  performance: "Perfformiad",
  "you-can-create-bespoke-action-plans":
    "Gallwch greu cynlluniau gweithredu pwrpasol sy'n hidlo'n uniongyrchol i mewn yma os caent eu creu o fewn eich cyfrif ServeFirst, yma gallwch greu gweithredoedd, amserlenni a pherchnogion ar unwaith wrth dracio perfformiad. -",
  "no-of-times-raised": "Nifer y Troeon a Godwyd",
  action: "Gweithred",
  "attribute-name": "Enw Priodoledd",
  "action-plan": "Cynllun Gweithredu",
  "that-by-adding-your-teams-to-the-ServeFirst-reporting-platform":
    "Trwy ychwanegu eich timau i blatfform adrodd ServeFirst y gallant hefyd fewngofnodi i weld eu perfformiad, hefyd; mae gennych y gallu i reoli eich tîm a chael mynediad at adroddiadau ychwanegol i ddeall sut rydych chi'n perfformio'n gyffredinol -",
  result: "Canlyniad",
  category: "Categori",
  "your-location-vs-all-location": "Eich Lleoliad yn erbyn Pob Lleoliad",
  "net-promoter-score": "Sgôr Hybu Net",
  "responses-breakdown": "Dadansoddiad Ymatebion",
  "trended-net-promoter-score": "Sgôr Hybu Net Tueddol",
  "trended-results": "Canlyniadau Tueddol",
  "net-promoter-score-info":
    "Mae Sgôr Hybu Net yn seiliedig ar % o hyrwyddwyr (Sgorio 5/5) - % o Wrthwynebwyr (Sgorio 1, 2 neu 3), gallwch ddysgu mwy am Sgôr Hybu Net trwy glicio ar y canlynol",
  "customer-feedback": "Adborth Cwsmer",
  logan: "Logan",
  "top-performer": "Perfformiwr Gorau",
  "rank-in-the-country": "Safle yn y Wlad",
  "ytd-score": "Sgôr YTD",
  "score-during-period": "Sgôr yn ystod y Cyfnod",
  "0-from-last-month": "0 o'r mis diwethaf",
  "total-responses-for-july-2021":
    "Cyfanswm Ymatebion ar gyfer Gorffennaf 2021",
  promoter: "Hyrwyddwr",
  "from-04-sep-2021-to-06-sep-2021": "O 04 Medi,2021 I 06 Medi,2021",
  "the-focus-currently-is-on": "Y ffocws ar hyn o bryd yw ar",
  "1-number-of-customers-have-stated-this-as-an-opportunity":
    "Mae 1 nifer o gwsmeriaid wedi nodi hyn fel cyfle.",
  "focus-for-the-month": "Ffocws ar gyfer y Mis",
  "download-pdf": "Lawrlwytho pdf",

  // Report Page New Report
  "total-responses": "Cyfanswm Ymatebion",
  duration: "Parhad",
  "customers-have-stated-this-as-an-opportunity":
    "mae cwsmeriaid wedi nodi hyn fel cyfle",
  "error-fetching-params": "Gwall wrth nôl paramedrau!",
  "previous-days-was": "Roedd {days} diwrnod blaenorol yn {score}",

  // Report Page Common LgCard
  "raised-on": "# Codwyd ar",
  results: "Canlyniadau",

  // Report Page Components AiSuggestions
  "analyzing-data-please-wait": "Dadansoddi data, arhoswch...",

  // Report Page Components CustomerFeedBack
  "view-report": "Gweld Adroddiad",
  "received-on": "Derbyniwyd ar",

  // Report Page Components ResponseBreakdown
  detractors: "Gwrthwynebwyr",
  nps: "NPS",

  // Report Page Components TrendResults
  "trend-results": "Canlyniadau Tuedd",

  // Survey helpers Utils
  "failed-to-fetch-the-pdf-file": "Methodd nôl y ffeil PDF",
  "error-generating-pdf-thumbnail": "Gwall wrth gynhyrchu llun bach PDF",
  "error-in-thumbnail-generation-function":
    "Gwall yn y swyddogaeth cynhyrchu llun bach",
  "failed-to-generate-pdf-thumbnail": "Methodd cynhyrchu llun bach PDF",

  // Survey Pages Audition
  "select-audit": "Dewis Archwiliad",

  // Survey Pages ClientConnect
  "select-atleast-min-options": "Dewiswch o leiaf {minOptions} opsiwn",
  "select-max-options": "Uchafswm {maxOptions} opsiwn a ganiateir!",
  "error-saving-your-response": "Gwall wrth gadw eich ymateb!",
  "failed-to-load-the-file": "Methodd llwytho'r ffeil!",
  "open-link": "Agor Dolen",
  download: "Lawrlwytho",
  details: "Manylion",
  title: "Teitl",
  description: "Disgrifiad",
  "general-info": "Gwybodaeth Gyffredinol",
  type: "Math",
  size: "Maint",
  "uploaded-by": "Uwchlwythwyd gan",

  // Survey Pages ClientConnect Intro
  "thank-you-for-your-time": "Diolch am eich amser!",

  // Survey Pages ClientConnect Content
  "review-content": "Adolygu cynnwys",

  // Survey Pages ClientConnect Survey
  "please-give-us-your-feedback": "Rhowch eich adborth i ni",
  "enter-your-response": "Rhowch eich ymateb",

  // Client Connect v2 (accordion UI)
  "client-connect-preview-hey": "Helo, {name}",
  "client-connect-preview-sent-from": "Anfonwyd gan {sender} - {date}",
  "client-connect-preview-step-of": "Cam {current} o {total}",
  "client-connect-preview-getting-started": "Dechrau arni",
  "client-connect-preview-getting-started-desc":
    "Cymerwch olwg ar yr adnoddau trosolwch a baratowyd ar eich cyfer.",
  "client-connect-preview-share-feedback": "Rhannwch eich adborth",
  "client-connect-preview-share-feedback-desc":
    "Mae eich mewnbwn yn ein helpu i adeiladu profiad gwell i chi.",
  "client-connect-preview-talk-leadership": "Sgwrsio â rheolaeth",
  "client-connect-preview-talk-leadership-desc":
    "Darllenwch neges rheolaeth a chadwch eich ateb.",
  "client-connect-preview-reviewed-these": "Rwyf wedi adolygu'r rhain",
  "client-connect-preview-send-feedback": "Anfon adborth",
  "client-connect-preview-finish-submit": "Gorffen ac anfon",
  "client-connect-preview-save-finish": "Gorffen ac anfon",
  "client-connect-preview-your-reply": "Eich ateb",
  "client-connect-preview-saved": "Wedi cadw",
  "client-connect-preview-edit": "Golygu",
  "client-connect-preview-pop-out": "Agor mewn ffenestr",
  "client-connect-preview-open": "Agor",
  "client-connect-preview-view": "Gweld",
  "client-connect-preview-welcome": "Croeso",
  "client-connect-preview-feedback": "Adborth",
  "client-connect-preview-save-message": "Anfon neges",
  "client-connect-preview-message-footer":
    "Mae eich neges yn mynd yn uniongyrchol at y tîm rheoli.",
  "client-connect-preview-leadership-placeholder": "Rhowch eich neges...",
  "client-connect-preview-thank-you": "Diolch",
  "client-connect-preview-thank-you-body":
    "Rydych wedi cwblhau Client Connect. Mae eich atebion arolwg a'ch neges wedi'u cyflwyno i'r tîm — byddant mewn cysylltiad cyn bo hir.",
  "client-connect-thank-you-message":
    "Diolch am eich amser. Mae eich adborth yn gwneud gwahaniaeth go iawn.",
  "client-connect-preview-review-answers": "Adolygu fy atebion",
  "client-connect-preview-back-dashboard": "Yn ôl i'r dangosfwrdd",
  "client-connect-preview-already-submitted":
    "Derbyniwyd eich adborth. Diolch! Croeso i chi archwilio'r deunyddiau uchod.",
  "enter-email-address": "Rhoi Cyfeiriad E-bost",
  "enter-phone-no": "Rhoi Rhif Ffôn",
  "product-type": "Math o Gynnyrch",
  "enter-number": "Rhowch rif",
  aspect: "Agwedd",

  // Survey Pages ClientConnect Director
  "i-am-constantly-seeking-ways-to-better-our-offerings-for-our-clientele":
    "Rwy'n chwilio'n gyson am ffyrdd i wella ein cynigion ar gyfer ein cwsmeriaid. Oes agweddau y gallem eu gwella yn eich barn chi?",
  "on-another-note-if-there-s-a-specific-topic-you-d-like-our-team-to-address-don-t-hesitate-to-share":
    "Ar nodyn arall, os oes pwnc penodol hoffech chi i'n tîm ei drafod, peidiwch â petruso i rannu. Nid wyf yma i wrando yn unig, ond i ymgysylltu a gweithredu ar eich pryderon neu syniadau.",
  "to-provide-enhanced-assistance-we-kindly-ask-for-your-details-including-your-name-email-address-and-contact-number":
    "I ddarparu cymorth gwell, gofynnwn yn garedig am eich manylion, gan gynnwys eich enw, cyfeiriad e-bost, a rhif cyswllt. Bydd y wybodaeth hon yn ein galluogi i ymateb yn brydlon a chysylltu â chi.",

  // Survey Pages Location
  "select-the-location-you-visited": "Dewiswch y lleoliad yr ymweloch ag ef",
  locations: "Lleoliadau",
  "is-this-your-current-location": "Ai dyma eich lleoliad presennol?",
  "nearest-location": "Lleoliad Agosaf",
  "loading-data": "Llwytho data...",
  "please-wait": "Arhoswch!",

  // Survey Pages Location Area
  "location-area": "Ardal Lleoliad",
  "select-location-area": "Dewis Ardal Lleoliad",

  // Survey Pages Login
  "please-enter-your-password": "Rhowch eich cyfrinair",
  "value-must-be-longer-than-3-characters":
    "Rhaid i'r gwerth fod yn hirach na 3 nod",
  "please-enter-your-email-address": "Rhowch eich cyfeiriad e-bost",
  password: "Cyfrinair",
  "internal-server-error": "Gwall Gweinydd Mewnol !",
  "sign-in": "Mewngofnodi",

  // Survey Pages SameDaySurvey
  "you-have-already-performed-this-survey":
    "Rydych chi eisoes wedi perfformio'r arolwg hwn !",
  "csat-link-invalid": "Nid yw'r ddolen arolwg hon yn ddilys mwyach.",

  // Survey Pages SurveyThankYou
  "your-feedback-has-been-submitted":
    "Mae eich adborth wedi'i gyflwyno. Eich rhif tocyn yw #",
  "a-member-of-the-team-will-be-in-touch-shortly":
    "Bydd aelod o'r tîm yn cysylltu'n fuan.",
  "would-you-also-like-to-rate-us-on-google":
    "Hoffech chi hefyd ein graddio ar Google?",
  "to-review-our-terms-and-conditions-please-click":
    "I adolygu ein Telerau ac Amodau, cliciwch",
  here: "Yma",
  "ticket-number-copied-to-clipboard": "Rhif tocyn wedi'i gopïo i'r clipfwrdd",

  // Survey Pages Welcome
  "visit-date": "Dyddiad Ymweliad",
  "visit-time-in": "Amser Ymweliad I Mewn",
  "please-select-date": "Dewiswch Ddyddiad",
  "guest-info": "Gwybodaeth Gwestai",
  "please-select-user": "Dewiswch Ddefnyddiwr",
  "get-started": "Dechrau Arni",

  // Survey Pages InventoryType
  "enter-value": "Rhoi gwerth",
  "getting-product-list": "Cael Rhestr Cynnyrch...",

  // Survey Pages NotesAndImage
  "upload-file": "Uwchlwytho Ffeil",

  // Survey Pages NumberType
  "enter-digit": "Rhoi digid",

  // Survey Pages TextArea
  "enter-your-comment": "Rhowch eich sylw",

  // Survey Pages Upload
  "file-size-should-be-less-than-10-mb":
    "Dylai maint y ffeil fod yn llai na 10 MB",
  "drag-you-files-here-file-size-less-than-10-mb-or":
    "Llusgwch eich ffeiliau yma, maint ffeil llai na 10 MB neu",
  "upload-or-drag-and-drop-your-files-here":
    "Llwytho i fyny neu llusgwch a gollwng eich ffeiliau yma",
  "browse-files": "Pori Ffeiliau",

  // Survey Pages Questions
  "next-question": "Cwestiwn Nesaf",
  "save-and-exit": "Cadw a Gadael",
  "failed-to-save-and-exit": "Methu cadw eich cynnydd. Ceisiwch eto.",
  "progress-saved-you-may-close-this-tab":
    "Mae eich cynnydd wedi'i gadw. Gallwch gau'r tab porwr hwn nawr.",
  "please-enter-at-least": "Rhowch o leiaf {min} nod.",
  "contact-no": "Rhif Cyswllt",
  "please-select-location": "Dewiswch Leoliad!",
  "please-select-survey": "Dewiswch Arolwg!",
  "please-enter-your-email-address-or-phone-number":
    "Rhowch eich cyfeiriad e-bost neu rif ffôn.",

  // Utils CompressFiles
  "compression-error": "Gwall cywasgu:",

  // Web Rating FrontLogin
  "enter-location-id": "Rhowch ID Lleoliad",
  "invalid-location-id": "ID Lleoliad Annilys",
  "location-id-required": "Mae angen id lleoliad",

  // Web Rating Index
  "please-tell-us-how-your-experience-was-today":
    "Dywedwch wrthym sut oedd eich profiad heddiw.",

  // Web Rating Negativefeedback
  "sorry-to-hear-you-didn-t-have-the-best-experience-today-with-us-please-could-you-highlight-what-went-wrong":
    "Mae'n ddrwg gennym glywed na chawsoch chi'r profiad gorau heddiw gyda ni, a allech chi nodi beth aeth o'i le?",
  "enter-valid-email-address": "Rhowch gyfeiriad e-bost dilys.",
  "can-we-get-in-touch-with-you": "Allwn ni gysylltu â chi?",

  // Web Rating Positivefeedback
  "enter-your-telephone-number": "Rhowch eich rhif ffôn",
  "write-your-feedback": "Ysgrifennwch eich adborth",

  // Web Rating Positivefeedback2
  "what-made-the-employee-name-stand-out-to-you":
    "Beth wnaeth i {employeeName} sefyll allan i chi?",
  team: "Tîm",

  // Web Rating PositivefeedbackForm
  "please-go-to-previous-step-and-select-employee-without-employee-selection-not-able-to-submit-feedback-form":
    "Ewch i'r cam blaenorol a dewiswch weithiwr, heb ddewis gweithiwr ni allwch gyflwyno'r ffurflen adborth",
  "share-us-your-experience-with-us-today":
    "Rhannwch eich profiad gyda ni heddiw...",
  "did-employee-name-provide-exceptional-service":
    "Wnaeth {employeeName} ddarparu gwasanaeth eithriadol?",
  "did-employee-name-stand-out-for-delivering-exceptional-service":
    "Wnaeth {employeeName} sefyll allan am ddarparu gwasanaeth eithriadol?",

  // Web Rating New apiHelpers loginHelpers
  "please-enter-user-name": "Rhowch enw defnyddiwr",
  "please-enter-password": "Rhowch gyfrinair",

  // Web Rating New RatingLocations
  search: "Chwilio",
  "select-loction-to-ratings": "Dewis lleoliad i raddio",
  location: "Lleoliad",
  "is-this-your-location": "Ai dyma eich Lleoliad?",
  "fetch-details-failed": "Methodd nôl manylion",

  // Web Rating New PositiveJourny EmployeDetail
  "click-as-many-as-you-want": "Cliciwch gymaint ag y dymunwch",
  "what-made-employee-name-stand-out-to-you":
    "Beth wnaeth i {employeeName} sefyll allan i chi?",
  "what-made-the-team-stand-out-to-you":
    "Beth wnaeth i'r tîm sefyll allan i chi?",

  // Web Rating New PositiveJourny EmployeService
  "did-we-stand-out-for-delivering-exceptional-service":
    "Wnaethom sefyll allan am ddarparu gwasanaeth eithriadol?",

  // Web Rating New NegativeJourny EmployePersonalDetail
  "leave-an-email-or-phone-number-if-you-want-us-to-get-in-touch-otherwise-just-leave-it-blank-then-press-next":
    "Gadewch e-bost neu rif ffôn os ydych chi eisiau i ni gysylltu, fel arall gadewch yn wag yna pwyswch nesaf",
  "anything-else-you-d-like-to-share":
    "Unrhyw beth arall hoffech chi ei rannu?",
  "enter-valid-email": "Rhowch e-bost dilys",
  message: "Neges",
  "by-signing-up-the-form-you-agree-to-our-terms-and-privacy":
    "Trwy gofrestru'r ffurflen, rydych yn cytuno i'n Telerau a Preifatrwydd.",

  // Web Rating New FrontWebLogin
  login: "Mewngofnodi",
  username: "Enw Defnyddiwr",

  // Web Rating New FrontRating
  "press-the-facial-expression-that-best-represents-how-you-feel-about-your-experience":
    "Pwyswch yr mynegiant wyneb sy'n cynrychioli orau sut rydych chi'n teimlo am eich profiad.",
  "getting-employee-list": "Cael rhestr gweithwyr",
  "getting-skill-data": "Cael data sgil",
  "getting-screen-saver": "Cael arbedwr sgrin",

  // Web Rating New CommonComponents ThankYouModal
  "thank-you-for-contacting-us": "Diolch am gysylltu â ni.",
  "we-ll-be-in-touch-very-soon": "Byddwn yn cysylltu'n fuan iawn.",

  // Web Rating New CommonComponents GoogleQrPage
  "you-can-follow-this-button-to-rate-us-on-google":
    "Gallwch ddilyn y botwm hwn i'n graddio ar Google",
  "rate-us-on-google": "Gradiwch ni ar Google",

  // Web Rating New CommonComponents ContactUsModal
  "contact-us": "Cysylltwch â Ni",
  "or-you-may-reach-us-on": "...neu gallwch ein cyrraedd ar.",
  "do-you-want-to-learn-more-about-serve-first":
    "Ydych chi eisiau dysgu mwy am Serve First?",

  // Web Rating New CommonComponents BottomBar
  saving: "Cadw",
  "please-enter-only-digits-for": "Rhowch ddigidau yn unig ar gyfer",
  "please-enter": "Rhowch",
  "enter-value-here": "Rhowch werth yma",

  // Survey Pages Questions Dropdown
  "please-select": "Dewiswch",
  "survey-retry-message":
    "Byddwch yn gallu perfformio'r arolwg hwn ar ôl {value} {unit}.",
  minute: "munud",
  minutes: "munudau",
  hour: "awr",
  hours: "oriau",
  day: "diwrnod",
  days: "diwrnodau",
  week: "wythnos",
  weeks: "wythnosau",
  month: "mis",
  months: "misoedd",
  clear: "Clirio",

  "powered-by": "Wedi'i bweru gan",
  "image-is-required": "Mae angen delwedd",
  "please-fill-all-required-contact-information":
    "Rhowch gwell y cyfan y manylion cyswllt sydd angen",

  "please-leave-any-extra-feedback-in-the-box-below":
    "Rhowch eich adborth yn y maes isod. Gallwch wneud yn uniongyrchol, yn annog neu amrywol.",
  "all-feedback-is-confidential": "Mae eich adborth yn annogol",
  "your-feedback-has-been-received-thank-you":
    "Mae eich adborth wedi'i derbyn, diolch",
  "close-page": "Cau tudalen",
  send: "Anfon",
  sending: "Anfonwch",
  "enter-your-feedback-here": "Rhowch eich adborth yma",
  "for-anything-else-please": "Ar gyfer unrhyw beth arall, rhowch ",
  "please-correct-the-custom-field-values":
    "Rhowch gwell y cyfan y manylion cyswllt sydd angen",
  "please-complete-all-required-contact-information":
    "Rhowch gwell y cyfan y manylion cyswllt sydd angen",
  "survey-cannot-be-submitted": "Nid yw'r arolwg yn cael ei gyflwyno",
  "please-enter-your-phone": "Rhowch eich rhif ffôn",
  "network-error-please-try-again":
    "Gwall rhwydwaith. Gwiriwch eich cysylltiad a cheisiwch eto.",
  "no-results-found": "Dim canlyniadau wedi'u dod",
  "drop-files-here": "Gollyngwch y ffeiliau yma...",
  "drag-drop-files":
    "Llusgwch a gollwng ffeiliau yma, neu cliciwch i ddewis ffeiliau",
  "max-5-files-5mb": "Uchafswm 5 ffeil, 5MB yr un, delweddau yn unig",
  remove: "Gwaredu",

  // Learning & Development

  "ld-module-title": "Dysgu a Datblygu",
  "ld-no-sign-in-required": "Nid oes angen mewngofnodi",
  "ld-progress-warning":
    "Peidiwch â chau'r ffenestr hon — nid yw eich cynnydd yn cael ei gadw a byddech yn gorfod dechrau eto.",
  "ld-loading-module": "Yn llwytho modiwl dysgu…",
  "ld-unable-load-module": "Methu llwytho modiwl dysgu.",
  "ld-package-not-configured": "Nid yw'r pecyn dysgu wedi'i ffurfweddu.",
  "ld-start-guidance": "Dechrau hyfforddiant",
  "ld-due-date": "Dyledus {date}",
  "ld-whats-involved": "Beth sy'n gynnwys",
  "ld-your-progress": "EICH CYNNYDD",
  "ld-step-of": "Cam {current} o {total}",
  "ld-watched-in-full": "Wedi'i wylio'n llawn",
  "ld-video-no-skip": "Gallwch ailwyntio, ond nid ymlaen",
  "ld-video-muted-counts": "Wedi tawelu — mae chwarae yn dal i gyfrif",
  "ld-maximize-document": "Ehangu'r ddogfen",
  "ld-minimize-document": "Lleihau'r ddogfen",
  "ld-read-percent": "{percent}% wedi'i ddarllen",
  "ld-end-of-document": "Diwedd y ddogfen",
  "ld-scroll-to-continue": "Sgroliwch i barhau",
  "ld-read-to-end": "Wedi darllen hyd at y diwedd",
  "ld-read-to-end-to-continue": "Darllenwch hyd at y diwedd i barhau",
  "ld-loading-document": "Yn llwytho dogfen…",
  "ld-pdf-preview-unavailable": "Methu rhagweld y PDF hwn yn y porwr.",
  "ld-pdf-page-alt": "{title} — tudalen {page}",
  "ld-knowledge-check": "GWIRIAD GWYBODAETH",
  "ld-knowledge-check-title": "{title} — gwiriad gwybodaeth",
  "ld-quiz-instruction":
    "Atebwch {count, plural, one {# gwestiwn} other {# cwestiwn}}. Marc pasio {passMark}%.",
  "ld-quiz-instruction-pass-only": "Marc pasio {passMark}%.",
  "ld-question-of": "CWESTIWN {current} O {total}",
  "ld-guidance-of": "HYFFORDDIANT {current} O {total}",
  "ld-loading-questionnaire": "Yn llwytho holiadur…",
  "ld-preparing-questions": "Yn paratoi eich cwestiynau",
  "ld-submit-answers": "Cyflwyno atebion",
  "ld-submitting": "Yn cyflwyno…",
  "ld-ready-to-submit": "Yn barod i gyflwyno eich atebion",
  "ld-answer-selected": "Ateb wedi'i ddewis",
  "ld-select-answer": "Dewiswch un ateb i barhau",
  "ld-pass-mark-note":
    "Mae angen {passMark}% neu fwy i basio. Ni ellir newid atebion ar ôl eu cyflwyno.",
  "ld-questionnaire-not-configured": "Nid yw'r holiadur wedi'i ffurfweddu.",
  "ld-unable-load-questionnaire": "Methu llwytho holiadur.",
  "ld-no-visible-questions":
    "Does dim cwestiynau ar gael ar gyfer y prawf gwybodaeth hwn ar hyn o bryd.",
  "ld-unable-submit-answers":
    "Methu cyflwyno atebion. Rhowch gynnig arall arni.",
  "ld-not-passed": "Heb basio",
  "ld-completed": "Wedi'i gwblhau",
  "ld-fail-title": "Bron iawn — rhowch gynnig arall arni",
  "ld-fail-description":
    "Cawsoch {score} — y marc pasio yw {passMark}%. Mae gennych {remaining} ar ôl.",
  "ld-attempts-remaining": "{count, plural, one {# ymgais} other {# ymgais}}",
  "ld-attempt-of": "Ymgais {current} o {total}",
  "ld-fail-alert":
    "Cymerwch eiliad i adolygu'r arweiniad eto, yna ail-wneud y gwiriad. Ar ôl eich ymgais olaf bydd y gwiriad yn cael ei gloi.",
  "ld-try-again": "Rhowch gynnig arall arni",
  "ld-review-guidance": "Adolygu arweiniad",
  "ld-locked-title": "Mae'r hyfforddiant hwn wedi'i gloi nawr",
  "ld-locked-description":
    "Cawsoch {score} — y marc pasio ar gyfer y pecyn hwn yw {passMark}%. Am resymau cydymffurfio ni allwch ei ail-wneud yma.",
  "ld-speak-to-manager": "Siaradwch â'ch rheolwr",
  "ld-locked-manager-copy":
    "Gall eich rheolwr dyletswydd ailddosbarthu {courseTitle} fel y gallwch weithio trwy'r arweiniad eto ac ail-geisio'r gwiriad.",
  "ld-close-window": "Gallwch gau'r ffenestr hon nawr.",
  "ld-close-window-safe": "Gallwch gau'r ffenestr hon yn ddiogel nawr.",
  "ld-success-title": "Llongyfarchiadau!",
  "ld-success-description":
    "Rydych wedi cwblhau {courseTitle} yn llwyddiannus. Mae hyn wedi'i gofnodi ar eich proffil hyfforddi — does dim mwy i'w wneud.",
  "ld-email-yourself": "Anfon copi atoch chi eich hun",
  "ld-email-copy-description":
    "Anfonwch gadarnhad o gwblhau i'ch mewnflwch ar gyfer eich cofnodion.",
  "ld-email-placeholder": "chi@cwmni.com",
  "ld-sent": "Wedi'i anfon",
  "ld-sending-email": "Yn anfon…",
  "ld-unable-send-email": "Methu anfon yr e-bost. Rhowch gynnig arall arni.",
  "ld-email-sent-success": "Anfonwyd yr e-bost cadarnhad yn llwyddiannus!",
  "ld-video-briefing": "Briffio fideo",
  "ld-document": "Dogfen",
  "ld-video-meta": "Fideo",
  "ld-video-meta-no-skip": "Fideo · dim neidio",
  "ld-document-meta": "Dogfen · PDF",
  "ld-document-meta-scroll": "Dogfen · PDF · sgroliwch i'r diwedd",
  "ld-video-instruction-full": "Gwyliwch yn llawn — ni allwch neidio ymlaen",
  "ld-video-instruction": "Gwyliwch y briffio, yna parhewch",
  "ld-document-instruction-scroll": "Sgroliwch i'r diwedd i barhau",
  "ld-document-instruction": "Adolygwch y ddogfen, yna parhewch",
  "ld-questionnaire": "Holiadur",
  "ld-confirmation": "Cadarnhad",
  "ld-question-count": "{count, plural, one {# gwestiwn} other {# cwestiwn}}",
  "ld-knowledge-check-subtitle": "Gwiriad gwybodaeth",
  "ld-score": "Sgôr",
  "ld-whats-involved-pass-mark":
    "Marc pasio {passMark}% · yn datgloi ar ôl arweiniad",
  "ld-document-type-pdf": "{documentType} · PDF",
};
